"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadModel = exports.getColors = void 0;
const getColors = (input) => {
    var _a, _b;
    if (!input)
        return { primary: null, secondary: null };
    if (typeof input !== "string")
        return { primary: null, secondary: null };
    const regex = /#[a-z0-9]*/gi;
    const matches = input.match(regex);
    return {
        primary: (_a = matches === null || matches === void 0 ? void 0 : matches[0]) !== null && _a !== void 0 ? _a : null,
        secondary: (_b = matches === null || matches === void 0 ? void 0 : matches[1]) !== null && _b !== void 0 ? _b : null,
    };
};
exports.getColors = getColors;
const loadModel = (input, space, contentType) => {
    return input;
};
exports.loadModel = loadModel;
